import axios from 'axios'
import {deepClone} from "./index";
import {Message, MessageBox} from 'element-ui';
import config from './config'
import router from '@/router'

// create an axios instance
const service = axios.create({
    baseURL: config.domain, // api的base_url
    timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(config => {
    config.withCredentials = true
    config.headers.token = btoa(encodeURIComponent(localStorage.token));
    return config
}, error => {
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => {
        if (response.data.code == 402) {
            router.push({ name: '登录'});
        }
        if (response.data.code == 401) {
            router.push({ name: '登录'});
        }
        return deepClone(response) 
    },
    error => {
        if (error.response.status == 400) {
            //参数错误
        } else if (error.response.status == 401) {
            //没有权限
            router.push({ name: '登录'});
        } else if (error.response.status == 500) {
            //内部异常
        } else {
            //其他异常
            Message({message: error.message, type: 'error', duration: 5 * 1000})
        }
        return Promise.reject(error)
    }
)

export default service

//创建默认请求
export function create_base_request(biz_name) {

    var biz_name;

    function query(params) {
        return service.post(biz_name + '/query', params)
    }

    function add(params) {
        return service.post(biz_name + '/add', params)
    }

    function update(params) {
        return service.post(biz_name + '/update', params)
    }

    function remove(params) {
        return service.post(biz_name + '/del', params)
    }

    return {
        query: query,
        add: add,
        update: update,
        remove: remove
    }

}




// WEBPACK FOOTER //
// ./src/utils/request.js